import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useCreateList } from './hooks/useLists';
import { SCREENS } from './AddToConstants';

const funcDefault = () => {
  // This is intentional
};

export const AddToContext = createContext({
  listDetails: {},
  projectRefetch: funcDefault,
  listRefetch: funcDefault,
  handleBackPress: funcDefault,
  setScreen: funcDefault,
  selectedProductDetails: {},
  setSelectedProductDetails: funcDefault,
  setShowSuccessMessage: funcDefault,
  addSelectedTo: funcDefault,
  addToType: '',
  products: [],
  groupedIntentsPreview: {},
  aiPrompt: { text: '', tab: null },
  setAiPrompt: funcDefault,
  aiSelectedTab: 'describe',
  setAiSelectedTab: funcDefault,
  selectedListId: null,
  selectedListName: '',
  setSelectedListId: funcDefault,
  setSelectedListName: funcDefault,
  sourceScreen: null,
  setSourceScreen: funcDefault
});

export const AddToClear = () => {
  const { screen, successMessage, setSuccessMessage } = useContext(AddToContext);

  useEffect(() => {
    if (successMessage?.length > 0 && screen !== SCREENS.DEFAULT) {
      setSuccessMessage('');
    }
  }, [screen]);
  return null;
};

export const AddToProvider = ({ children, value }) => {
  const [successMessage, setSuccessMessage] = useState('');
  const [abandonWarning, setAbandonWarning] = useState({ show: false, action: 'CLOSE' });
  const [canShowWarning, setCanShowWarning] = useState(false);
  const [groupedIntentsPreview, setGroupedIntentsPreview] = useState({});
  const [generatedIntents, setGeneratedIntents] = useState([]);
  const [aiPrompt, setAiPrompt] = useState({ text: '', tab: null });
  const [aiSelectedTab, setAiSelectedTab] = useState('describe');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [previousScreen, setPreviousScreen] = useState(null);
  const [mcvisId, setMcvisId] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);

  // Enhanced setScreen that automatically tracks previous screen
  const setScreenWithHistory = (newScreen) => {
    if (newScreen !== value.screen) {
      if (value.screen !== SCREENS.AI_LOADING_ANIMATION) {
        setPreviousScreen(value.screen);
      }
      value.setScreen(newScreen);
    }
  };
  const [selectedListId, setSelectedListId] = useState(null);
  const [selectedListName, setSelectedListName] = useState('');
  const [sourceScreen, setSourceScreen] = useState(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setMcvisId(window._aape?.ECID || null);
    }

    return () => {
      setSuccessMessage('');
      setSelectedListId(null);
      setSelectedListName('');
      setSourceScreen(null);
    };
  }, []);

  useEffect(() => {
    if (generatedIntents?.length === 0
      && groupedIntentsPreview?.groupedIntents?.length > 0
    ) {
      setGeneratedIntents(groupedIntentsPreview.groupedIntents);
    }

    if (generatedIntents?.length > 0 && groupedIntentsPreview?.groupedIntents?.length === 0) {
      setGeneratedIntents([]);
    }
  }, [groupedIntentsPreview]);

  return (
    <AddToContext.Provider value={{
      ...value,
      setScreen: setScreenWithHistory,
      successMessage,
      setSuccessMessage,
      abandonWarning,
      setAbandonWarning,
      canShowWarning,
      setCanShowWarning,
      groupedIntentsPreview,
      generatedIntents,
      setGroupedIntentsPreview,
      aiPrompt,
      setAiPrompt,
      aiSelectedTab,
      setAiSelectedTab,
      searchKeyword,
      setSearchKeyword,
      previousScreen,
      setPreviousScreen,
      searchLoading,
      setSearchLoading,
      selectedListId,
      setSelectedListId,
      selectedListName,
      setSelectedListName,
      sourceScreen,
      setSourceScreen,
      mcvisId
    }}
    >
      {children}
      <AddToClear />
    </AddToContext.Provider>
  );
};

AddToProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.shape({
    screen: PropTypes.string,
    setScreen: PropTypes.func,
  })
};

AddToProvider.defaultProps = {
  value: {}
};
